import React, { useState } from "react";
import { useSelector } from 'react-redux';
// import DELETE_PUBLISHER_USER_MUTATION from "../../graphql/mutations/DeletePublisherUser.js";
import { useMutation } from '@apollo/client';
import UPDATE_USER_ROLE_MUTATION from "../../graphql/mutations/UpdateUserRole.js";

import {
  Button,
  Table,
  Pane,
  IconButton,
  Combobox,
  TickIcon,
  CrossIcon,
  Badge,
  Tooltip
} from 'evergreen-ui';

function GroupUser(props) {
  const user = useSelector((state) => state.user.value);

  const [thisuser, setThisuser] = useState(props.publisheruser);
  const [changerole, setChangerole] = useState(false);

  const isCurrentUser = parseInt(props.publisheruser.user.id) === parseInt(user);
  const isOwnerRole = thisuser.role.name === "owner";

  // Only owners/admins with admin privileges can change roles, and owners can't change their own role
  const canChangeRole = props.hasAdminPrivileges && !isCurrentUser && !isOwnerRole;

  // Only owners/admins with admin privileges can remove users, and owners can't remove themselves
  const canRemoveUser = props.hasAdminPrivileges && !isCurrentUser;

  const handleChangerole = (val) => {
    setChangerole(val);
  }

  const handleUpdateUser = (change) => {
    // Create a new object with the updated role
    const updatedUser = {
      ...thisuser,
      role: {
        ...thisuser.role,
        id: change.roleId,
        name: change.roleName
      }
    };
    setThisuser(updatedUser);
  }

  // const [deletePublisherUser, { data }] = useMutation(DELETE_PUBLISHER_USER_MUTATION);

  return (
    <Table.Row className="table-row" value="">
      <Table.TextCell flexShrink={0} flexGrow={3}>{thisuser.user.email}</Table.TextCell>
      {!changerole ? (
        <Table.TextCell flexShrink={0} flexGrow={2}>
          <Tooltip content={canChangeRole ? "Click to change role" : isOwnerRole ? "Owner role cannot be changed" : "You don't have permission to change roles"}>
            <Button
              disabled={!canChangeRole}
              onClick={e => setChangerole(true)}
              appearance={isOwnerRole ? "primary" : "default"}
              size="small"
            >
              {thisuser.role.name}
            </Button>
          </Tooltip>
        </Table.TextCell>
      ) : (
        <Table.TextCell flexShrink={0} flexGrow={2}>
          <SelectUserRole
            mode="update"
            userroles={props.userroles}
            publisheruser={thisuser}
            handleChangerole={handleChangerole}
            handleUpdateUser={handleUpdateUser}
          />
        </Table.TextCell>
      )}
      <Table.TextCell flexShrink={0} flexGrow={1}>
        <Badge color="green">Active</Badge>
      </Table.TextCell>
      <Table.TextCell flexShrink={0} flexGrow={2}>
        <Tooltip content={canRemoveUser ? "Remove user from team" : isCurrentUser ? "You cannot remove yourself" : "Only admins can remove team members"}>
          <Button
            disabled={!canRemoveUser}
            intent="danger"
            onClick={e => props.handleDeletePublisherUser(thisuser.id)}
            size="small"
          >
            Remove
          </Button>
        </Tooltip>
      </Table.TextCell>
    </Table.Row>
  )
}

export default GroupUser;


function SelectUserRole(props) {
  const [selectedRole, setSelectedRole] = useState(
    props.publisheruser ?
    {
      label: props.publisheruser.role.name,
      value: props.publisheruser.role.id
    } :
    { label: "Admin", value: "2" }
  );

  // Filter out the owner role from dropdown unless the current user is already an owner
  const dropdownItems = props.userroles
    .filter(item => item.name !== "owner" || props.publisheruser.role.name === "owner")
    .map(item => {
      return {label: item.name, value: item.id};
    });

  const [updateUserRole, { data }] = useMutation(UPDATE_USER_ROLE_MUTATION, {
    onCompleted: (data) => {
      props.handleUpdateUser({
        id: parseInt(props.publisheruser.id),
        roleId: parseInt(selectedRole.value),
        roleName: selectedRole.label
      });
      props.handleChangerole(false);
    }
  });

  return (
    <Pane display="flex" flexDirection="row" justifyContent="flex-start" alignItems="flex-start">
      <Combobox
        initialSelectedItem={{ label: props.publisheruser.role.name }}
        items={dropdownItems}
        itemToString={item => (item ? item.label : '')}
        onChange={selected => setSelectedRole(selected)}
        width={120}
      />
      <IconButton
        icon={TickIcon}
        intent="success"
        onClick={e => {
          updateUserRole({
            variables: {
              id: parseInt(props.publisheruser.id),
              role: parseInt(selectedRole.value)
            }
          });
        }}
      />
      <IconButton icon={CrossIcon} intent="danger" onClick={e => props.handleChangerole(false)} />
    </Pane>
  )
}
